import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ErrorConstants } from 'src/app/shared/constants/error.constants';

@Component({
  standalone: false,
  selector: 'app-exposure-reduction-plan-status',
  templateUrl: './exposure-reduction-plan-status.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./exposure-reduction-plan-status.component.scss'],
})
export class ExposureReductionPlanStatusComponent implements OnInit {

  errorHtml: string = "";

  constructor(
  ) {
    this.errorHtml = ErrorConstants.errorHtml;
  }

  ngOnInit(): void {
  }

}
